import { Controller } from "stimulus"
import * as Turbo from "@hotwired/turbo"

export default class extends Controller {
  static targets = ["deleteAllModal", "deleteOneModal"]

  connect() {
    this._onKeydown = (event) => {
      if (event.key !== "Escape") return
      if (this.hasDeleteOneModalTarget && this._isOpen(this.deleteOneModalTarget)) this.hideDeleteOneModal()
      if (this.hasDeleteAllModalTarget && this._isOpen(this.deleteAllModalTarget)) this.hideDeleteAllModal()
    }
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
  }

  _isOpen(target) {
    return target && target.style.display !== "none"
  }

  showDeleteAllModal(event) {
    event.preventDefault()
    this.deleteAllModalTarget.style.display = "flex"
  }

  hideDeleteAllModal(event) {
    if (event) event.preventDefault()
    this.deleteAllModalTarget.style.display = "none"
  }

  showDeleteOneModal(event) {
    event.preventDefault()
    event.stopPropagation()
    this._pendingDeleteSessionId = event.currentTarget.dataset.sessionId

    document.querySelectorAll('.c-dropdown__content--visible').forEach(dropdown => {
      dropdown.classList.remove('c-dropdown__content--visible')
      dropdown.classList.add('c-dropdown__content--hidden')
    })

    this.deleteOneModalTarget.style.display = "flex"
  }

  hideDeleteOneModal(event) {
    if (event) event.preventDefault()
    this.deleteOneModalTarget.style.display = "none"
    this._pendingDeleteSessionId = null
  }

  confirmDeleteOne(event) {
    event.preventDefault()
    const sessionId = this._pendingDeleteSessionId
    if (!sessionId) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(`/chat_sessions/${sessionId}`, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      }
    }).then(response => {
      if (response.ok) {
        this.deleteOneModalTarget.style.display = "none"

        const currentSessionInput = document.querySelector('input[name="chat_session_id"]')
        const isCurrentSession = currentSessionInput && currentSessionInput.value === sessionId

        const sidebarTitle = document.getElementById(`sidebar-session-title-${sessionId}`)
        if (sidebarTitle) {
          const conversationItem = sidebarTitle.closest('.sidebar-conversation-item')
          if (conversationItem) {
            conversationItem.remove()
          }
        }

        const mobileItem = this.element.querySelector(`.conversation-item[data-session-id="${sessionId}"]`)
        if (mobileItem) {
          mobileItem.remove()
        }

        this._cleanupEmptyGroups()

        if (isCurrentSession) {
          Turbo.visit("/chat_session", { action: "advance" })
        }
      }
    }).catch(error => {
      console.error("Failed to delete conversation:", error)
      this.deleteOneModalTarget.style.display = "none"
    })

    this._pendingDeleteSessionId = null
  }

  confirmDeleteAll(event) {
    event.preventDefault()
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch("/chat_sessions/destroy_all", {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      }
    }).then(response => {
      if (response.ok) {
        this.deleteAllModalTarget.style.display = "none"

        const historyList = document.querySelector('[data-chat-sidebar-target="historyList"]')
        if (historyList) historyList.innerHTML = ""

        const deleteAllLink = document.querySelector('.chat-history-delete-all-link')
        if (deleteAllLink) {
          deleteAllLink.closest('.tw-flex.tw-justify-end')?.remove()
        }

        Turbo.visit("/chat_session", { action: "advance" })
      }
    }).catch(error => {
      console.error("Failed to delete all conversations:", error)
      this.deleteAllModalTarget.style.display = "none"
    })
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  _cleanupEmptyGroups() {
    document.querySelectorAll('[data-chat-sidebar-target="historyList"] .tw-mb-4').forEach(group => {
      if (group.querySelectorAll('.sidebar-conversation-item').length === 0) {
        group.remove()
      }
    })

    this.element.querySelectorAll('.tw-mb-6').forEach(group => {
      if (group.querySelectorAll('.conversation-item').length === 0) {
        group.remove()
      }
    })

    
    const historyList = document.querySelector('[data-chat-sidebar-target="historyList"]')
    if (historyList && historyList.querySelectorAll('.sidebar-conversation-item').length === 0) {
      const deleteAllLink = document.querySelector('.chat-history-delete-all-link')
      if (deleteAllLink) {
        deleteAllLink.closest('.tw-flex.tw-justify-end')?.remove()
      }
    }

    
    if (this.element.querySelectorAll('.conversation-item').length === 0) {
      const deleteAllLink = this.element.querySelector('.chat-history-delete-all-link')
      if (deleteAllLink) {
        deleteAllLink.closest('.tw-flex.tw-justify-end')?.remove()
      }
    }
  }
}
